import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import type { CancelablePromise } from '@/api/generated-client/core/CancelablePromise';
import { TenantDto } from '@/api/models/tenant.dto';
import { UpdateTenantRequestDto } from '@/api/models/update-tenant-request.dto';

export class TenantApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  private url = '/tenants';

  public getTenant(): CancelablePromise<TenantDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: `${this.url}/current`,
      mediaType: 'application/json',
    });
  }

  public updateTenant(
    changes: UpdateTenantRequestDto,
  ): CancelablePromise<TenantDto> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: `${this.url}/current`,
      mediaType: 'application/json',
      body: changes,
    });
  }
}
